import Reveal from "@/components/base/Reveal";
import { WHATSAPP_DISPLAY, whatsappLink } from "@/constants/site";

export default function HelpCta() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl border border-primary-200 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 p-8 md:p-14">
            <div className="nx-glow absolute -right-20 -top-20 h-72 w-72 opacity-60"></div>
            <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.4fr_1fr]">
              <div>
                <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                  Não sabe qual estrutura sua empresa precisa?
                </h2>
                <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600">
                  Conte o que você precisa e nossa equipe ajuda você a encontrar a solução mais
                  adequada para o seu projeto.
                </p>
              </div>
              <div className="flex flex-col gap-3">
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
                  Falar com um especialista
                </a>
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-4 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
                >
                  <i className="ri-phone-line text-lg text-secondary-600" aria-hidden="true"></i>
                  WhatsApp {WHATSAPP_DISPLAY}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}